<template>
	<div>
		<component :is="resolvedView" v-bind="resolvedData"></component>
	</div>
</template>

<script>
import ViewResolver from '../../services/ViewResolver';

export default {
	props: {
		dataUrl: String,
		view: String,
		data: Object
	},
	data() {
		return {
			resolvedView: null,
			resolvedData: {},
			loading: false
		}
	},
	async created() {

		this.loading = true

		try {
			const [view, data] = await Promise.all([
				ViewResolver.resolveView(this.view),
				ViewResolver.resolveData(this.dataUrl,this.data)
			]);

			this.resolvedView = view
			this.resolvedData = data;

		} catch (e) {

			this.$bus.$emit('modal:error', { response: e.response})

		} finally {
			this.loading = false;
		}
	}
}
</script>
